import React, { FunctionComponent, MouseEvent, ReactNode } from 'react';

import cn from 'classnames';

import SvgImage from '../../svg-image';
import { ImageName } from '../../svg-image/images';
import classes from './style.css';

export type OptionProps = {
    title: string;
    content: ReactNode;
    iconName?: ImageName;
    icon?: ReactNode;
    className?: string | null;
    fillIconColor?: string;
    disabled?: boolean;
    onClick?: (event: MouseEvent) => void;
    link?: string;
    checked?: boolean;
};

export const MorePopupOption: FunctionComponent<OptionProps> = ({
    onClick,
    title,
    iconName,
    icon,
    fillIconColor,
    disabled,
    className,
    content,
    link,
    checked,
}) => {
    const handleClick = (event: MouseEvent) => {
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        onClick?.(event);
    };

    const getIcon = () => {
        if (icon) {
            return <div className={classes.iconWrapper}>{icon}</div>;
        }
        if (iconName) {
            return (
                <SvgImage
                    imageName={iconName}
                    style={{
                        width: 24,
                        height: 24,
                        marginRight: 8,
                    }}
                    fill={fillIconColor ? fillIconColor : 'currentColor'}
                />
            );
        }
        return null;
    };

    const getContent = () => (
        <>
            {getIcon()}
            <span className={classes.content}>{content}</span>
            {checked ? <SvgImage className={classes.checkedIcon} imageName="checkmark" /> : null}
        </>
    );

    const commonProps = {
        className: cn(classes.option, className, { [classes.disabled]: disabled }),
        title,
        'aria-disabled': disabled,
    };
    if (link) {
        return (
            <a onClick={handleClick} target="_blank" rel="noreferrer" href={link} {...commonProps}>
                {getContent()}
            </a>
        );
    } else {
        return (
            <div onClick={handleClick} {...commonProps}>
                {getContent()}
            </div>
        );
    }
};
